export default "__VITE_ASSET__CmqX4yDb__"